import { Box, FormControl, FormLabel, Stack, VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useState, useMemo } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    dropDownFormStyle,
    formInputStyles,
    formLabelStyling,
    formSelectStyles,
    stackSpacing,
    stackStyling,
    textBoxStyling,
} from 'components/forms/new/formStyles';
import { PROTOCOL, protocolOptions } from 'pages/resources/pbx/constants';

const ProtocolField = ({ values, darkMode, touched }) => {
    const [isHovered, setIsHovered] = useState(false);

    const baseStyles = dropDownFormStyle(darkMode);

    const handleChange = (selectedOption, form) => {
        const protocolValue =
            selectedOption?.value !== undefined
                ? parseInt(selectedOption.value)
                : PROTOCOL.DEFAULT;
        form.setFieldValue('protocol', protocolValue);
    };

    const selectedProtocol = useMemo(() => {
        const protocolValue =
            values.protocol !== undefined ? values.protocol : PROTOCOL.DEFAULT;
        return (
            protocolOptions.find((option) => option.value === protocolValue) ||
            null
        );
    }, [values.protocol]);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Protocol</FormLabel>
                <Field name="protocol">
                    {({ field, form: { setFieldValue, setTouched } }) => (
                        <Box
                            flex="1"
                            sx={{
                                paddingTop: '15px',
                                ...formSelectStyles,
                            }}>
                            <VStack width="100%" alignItems="normal">
                                <Select
                                    {...field}
                                    tabSelectsValue
                                    openMenuOnFocus
                                    placeholder="Select protocol"
                                    sx={{
                                        ...textBoxStyling,
                                        color: darkMode
                                            ? 'dark.textDark'
                                            : null,
                                        background: darkMode
                                            ? 'dark.bgDark'
                                            : null,
                                        borderColor: darkMode
                                            ? 'dark.tcap-borderGray'
                                            : null,
                                    }}
                                    value={selectedProtocol}
                                    options={protocolOptions}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    chakraStyles={baseStyles}
                                    onChange={(selectedOption) =>
                                        handleChange(selectedOption, {
                                            setFieldValue,
                                        })
                                    }
                                    onBlur={() => {
                                        setTouched({
                                            ...touched,
                                            protocol: true,
                                        });
                                    }}
                                    selectedOptionColor="brand"
                                />
                            </VStack>
                        </Box>
                    )}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label="Protocol configuration for Registrar: UDP, TCP, TLS or Default"
                        ariaLabel="protocol-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ProtocolField;
